import { createQueryHook } from '../internal/createQueryHook';
import { teams } from '../queries/teams';

/**
 * @deprecated Use `teams.detail()` with `useQuery` directly.
 */
export const useTeam = createQueryHook(({ teamKey }: { teamKey: string }) => teams.detail({ teamKey }));
